import { Check, ChevronDown, Filter } from "lucide-react";

import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { LOAD_STATUS_FILTER_OPTIONS, buildDefaultLoadFilters, statusFilterLabel } from "./loadsPageUtils";

export const LoadsFiltersPanel = ({ filters, lookups, onResetSavedFilters, onSaveFilters, setFilters, toggleStatusFilter, updateFilter }) => (
  <section className="panel-surface space-y-4 px-5 py-5" data-testid="loads-filters-panel">
    <div className="flex items-center gap-2">
      <Filter className="h-4 w-4 text-zinc-500" />
      <p className="text-sm font-semibold text-zinc-900">Filters</p>
    </div>
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      <select className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-filter-customer" name="customer_id" onChange={updateFilter} value={filters.customer_id}>
        <option value="">All customers</option>
        {lookups.customers.map((customer) => <option key={customer.id} value={customer.id}>{customer.customer_name}</option>)}
      </select>
      <Popover>
        <PopoverTrigger asChild>
          <button className="flex items-center justify-between rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm text-zinc-900" data-testid="loads-filter-status" type="button">
            <span className="truncate text-left">{statusFilterLabel(filters.status)}</span>
            <ChevronDown className="ml-3 h-4 w-4 shrink-0 text-zinc-500" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-[280px] rounded-2xl border border-zinc-200 bg-white p-2" data-testid="loads-filter-status-dropdown">
          <div className="space-y-1">
            {LOAD_STATUS_FILTER_OPTIONS.map((statusValue) => {
              const selected = filters.status.includes(statusValue);
              return (
                <button
                  className={`flex w-full items-center justify-between rounded-xl px-3 py-2 text-sm transition-colors ${selected ? "bg-zinc-900 text-white" : "text-zinc-700 hover:bg-zinc-100"}`}
                  data-testid={`loads-filter-status-option-${statusValue.replace(/\s+/g, "-").toLowerCase()}`}
                  key={statusValue}
                  onClick={() => toggleStatusFilter(statusValue)}
                  type="button"
                >
                  <span>{statusValue}</span>
                  {selected ? <Check className="h-4 w-4" /> : null}
                </button>
              );
            })}
          </div>
        </PopoverContent>
      </Popover>
      <select className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-filter-shipment-direction" name="shipment_direction" onChange={updateFilter} value={filters.shipment_direction}>
        <option value="">All shipment directions</option>
        {lookups.shipment_directions.map((direction) => <option key={direction} value={direction}>{direction}</option>)}
      </select>
      <select className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-filter-truck" name="truck_id" onChange={updateFilter} value={filters.truck_id}>
        <option value="">All trucks</option>
        {lookups.trucks.map((truck) => <option key={truck.id} value={truck.id}>{truck.truck_number}</option>)}
      </select>
      <select className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-filter-trailer" name="trailer_id" onChange={updateFilter} value={filters.trailer_id}>
        <option value="">All trailers</option>
        {lookups.trailers.map((trailer) => <option key={trailer.id} value={trailer.id}>{trailer.trailer_number}</option>)}
      </select>
      <select className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-filter-driver" name="driver_id" onChange={updateFilter} value={filters.driver_id}>
        <option value="">All drivers</option>
        {lookups.drivers.map((driver) => <option key={driver.id} value={driver.id}>{driver.full_name}</option>)}
      </select>
      <input className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-filter-start-date" name="start_date" onChange={updateFilter} type="date" value={filters.start_date} />
      <input className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-filter-end-date" name="end_date" onChange={updateFilter} type="date" value={filters.end_date} />
      <div className="grid grid-cols-2 gap-3">
        <select className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-sort-by" name="sort_by" onChange={updateFilter} value={filters.sort_by}>
          <option value="load_number">Load #</option>
          <option value="customer">Customer</option>
          <option value="pickup_datetime">Planned picked</option>
          <option value="delivery_datetime">Planned delivered</option>
          <option value="status">Status</option>
        </select>
        <select className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm" data-testid="loads-sort-direction" name="sort_dir" onChange={updateFilter} value={filters.sort_dir}>
          <option value="asc">Asc</option>
          <option value="desc">Desc</option>
        </select>
      </div>
      <button className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm font-semibold text-zinc-700 transition hover:border-zinc-900 hover:text-zinc-900" data-testid="loads-filter-clear-button" onClick={() => setFilters(buildDefaultLoadFilters())} type="button">Reset current</button>
    </div>
    <div className="flex flex-wrap items-center gap-3" data-testid="loads-saved-filter-actions">
      <button className="rounded-2xl bg-zinc-900 px-4 py-3 text-sm font-semibold text-white transition hover:bg-zinc-800" data-testid="loads-save-filters-button" onClick={onSaveFilters} type="button">Save filters</button>
      <button className="rounded-2xl border border-zinc-200 bg-white px-4 py-3 text-sm font-semibold text-zinc-700 transition hover:border-zinc-900 hover:text-zinc-900" data-testid="loads-reset-saved-filters-button" onClick={onResetSavedFilters} type="button">Reset saved filters</button>
    </div>
  </section>
);